// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"750":"b754e29e","879":"610fd353"}[chunkId] + ".chunk.js";
};